module.exports = __webpack_public_path__ + "static/img/top_img1.f626b77.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news/top_img1.png
// module id = Qc+3
// module chunks = 1